import { ABMGenerico } from "src/general_components/ABMGenerico";

export const Funcionalidades = () => {
    const modelo = "funcionalidades";

    return (
        <>
            <ABMGenerico modelo={modelo} titulo={"Funcionalidades"} />
        </>
    );
};
